// Single SDK entry point for the supabase provider.
//
// Mirrors firebase/client.js: a lazy, memoized handle the provider modules
// call at CALL TIME (never at module top level). Importing any supabase
// provider module has no side effects — a firebase-only build can statically
// import this provider (S3's dual-import) without constructing a Supabase
// client or throwing on missing VITE_SUPABASE_* env. The missing-env error
// fires only when getClient() is actually invoked under VITE_DATA_PROVIDER=
// supabase.
import { createClient } from '@supabase/supabase-js';

let _client = null;

export function getClient() {
  if (_client) return _client;
  const env = import.meta.env || {};
  const url = env.VITE_SUPABASE_URL;
  const key = env.VITE_SUPABASE_ANON_KEY;
  if (!url || !key) {
    throw new Error(
      'Missing Supabase env vars: VITE_SUPABASE_URL, VITE_SUPABASE_ANON_KEY. ' +
        'Set them in .env.local or your host env panel (only required when ' +
        'VITE_DATA_PROVIDER=supabase).',
    );
  }
  // eventsPerSecond throttles realtime client→server messages, matching the
  // S4 doc. Constructed once and memoized so every provider module shares one
  // websocket connection.
  _client = createClient(url, key, {
    realtime: { params: { eventsPerSecond: 10 } },
  });
  return _client;
}
